class RitualSteps extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('[data-ritual-track]');
    this.cards = Array.from(this.querySelectorAll('[data-ritual-card]'));
    this.dots = Array.from(this.querySelectorAll('[data-ritual-dot]'));
    this.nextBtn = this.querySelector('[data-ritual-next]');

    if (!this.track || this.cards.length === 0) return;

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.goToNext());
    }

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.getAttribute('data-index'), 10);
        this.goToIndex(index);
      });
    });

    this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
  }

  getCurrentIndex() {
    const trackRect = this.track.getBoundingClientRect();
    const center = trackRect.left + trackRect.width / 2;

    let closestIndex = 0;
    let closestDistance = Infinity;

    this.cards.forEach((card, index) => {
      const rect = card.getBoundingClientRect();
      const cardCenter = rect.left + rect.width / 2;
      const distance = Math.abs(cardCenter - center);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  goToIndex(index) {
    const card = this.cards[index];
    if (!card) return;
    this.track.scrollTo({
      left: card.offsetLeft - this.track.offsetLeft,
      behavior: 'smooth'
    });
  }

  goToNext() {
    const current = this.getCurrentIndex();
    const next = (current + 1) % this.cards.length;
    this.goToIndex(next);
  }

  onScroll() {
    if (this.scrollTimeout) clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => {
      const current = this.getCurrentIndex();
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === current);
      });
    }, 80);
  }
}

customElements.define('ritual-steps', RitualSteps);
